import { render, staticRenderFns } from "./skysource-search.vue?vue&type=template&id=15840a0a"
import script from "./skysource-search.vue?vue&type=script&lang=js"
export * from "./skysource-search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports